/*
 * Copyright (c) 2026. Amazon.com, Inc. or its affiliates. All rights reserved.
 */

// Shared HMAC secret for invite links — imported by both the client verify
// (inviteToken.ts) and the mint script (mint-invite.mjs). "Semi-secure": it
// ships in the client bundle, matching the deliberate invite-gate design.
export const INVITE_SECRET = 'aSpYLae1OZxiDGhmbByq0Gm_QXc2yCLk'
